export interface FetchCacheOptions {
  ttlMs?: number;
}

export class FetchCache<T> {
  private cachedValue: T | null = null;
  private lastFetchedAtMs = 0;
  private inflight: Promise<T> | null = null;
  private readonly ttlMs: number;

  constructor(private fetcher: () => Promise<T>, options?: FetchCacheOptions) {
    this.ttlMs = options?.ttlMs ?? 5 * 60 * 1000;
  }

  async get(): Promise<T> {
    const now = Date.now();
    const isStale = now - this.lastFetchedAtMs > this.ttlMs;
    if (this.cachedValue == null || isStale) {
      if (!this.inflight) {
        this.inflight = this.fetcher()
          .then((value) => {
            this.cachedValue = value;
            this.lastFetchedAtMs = Date.now();
            return value;
          })
          .finally(() => {
            this.inflight = null;
          });
      }
      return this.inflight;
    }
    return this.cachedValue;
  }

  invalidate(): void {
    this.cachedValue = null;
    this.lastFetchedAtMs = 0;
  }

  setFetcher(fetcher: () => Promise<T>): void {
    this.fetcher = fetcher;
    this.invalidate();
  }
}
